module.exports = __webpack_public_path__ + "img/ipars2.6cf08ca8.jpg";